/* tslint:disable */
/* eslint-disable */
/**
 * Toki Public APIs
 * API Gateway for all Toki Public APIs
 *
 * The version of the OpenAPI document: 4.8.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { ChangeInvoiceStatusV1200ResponseFromJSON, GetCustomerInvoicesV1200ResponseFromJSON, GetInvoiceDetailsV1200ResponseFromJSON, InvoiceStatusToJSON, } from '../models/index';
/**
 *
 */
export class InvoiceApi extends runtime.BaseAPI {
    /**
     * Change Invoice Status
     * Change Invoice Status
     */
    async changeInvoiceStatusV1Raw(requestParameters, initOverrides) {
        if (requestParameters['invoiceNumber'] == null) {
            throw new runtime.RequiredError('invoiceNumber', 'Required parameter "invoiceNumber" was null or undefined when calling changeInvoiceStatusV1().');
        }
        if (requestParameters['data'] == null) {
            throw new runtime.RequiredError('data', 'Required parameter "data" was null or undefined when calling changeInvoiceStatusV1().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = await this.configuration.apiKey("x-api-key"); // api_key authentication
        }
        const response = await this.request({
            path: `/v1/invoices/{invoice_number}/status`.replace(`{${"invoice_number"}}`, encodeURIComponent(String(requestParameters['invoiceNumber']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceStatusToJSON(requestParameters['data']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeInvoiceStatusV1200ResponseFromJSON(jsonValue));
    }
    /**
     * Change Invoice Status
     * Change Invoice Status
     */
    async changeInvoiceStatusV1(requestParameters, initOverrides) {
        const response = await this.changeInvoiceStatusV1Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Returns a list of invoices that haven\'t been paid yet
     * Get all unpaid invoices
     */
    async getAllDueInvoicesV1Raw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }
        if (requestParameters['customerIdIn'] != null) {
            queryParameters['customer_id__in'] = requestParameters['customerIdIn'];
        }
        if (requestParameters['fromDate'] != null) {
            queryParameters['from_date'] = requestParameters['fromDate'].toISOString().substring(0, 10);
        }
        if (requestParameters['toDate'] != null) {
            queryParameters['to_date'] = requestParameters['toDate'].toISOString().substring(0, 10);
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("firebase", []);
        }
        const response = await this.request({
            path: `/v1/invoices/due`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetCustomerInvoicesV1200ResponseFromJSON(jsonValue));
    }
    /**
     * Returns a list of invoices that haven\'t been paid yet
     * Get all unpaid invoices
     */
    async getAllDueInvoicesV1(requestParameters = {}, initOverrides) {
        const response = await this.getAllDueInvoicesV1Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List of all invoices
     */
    async getAllInvoicesV1Raw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }
        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }
        if (requestParameters['orderBy'] != null) {
            queryParameters['order_by'] = requestParameters['orderBy'];
        }
        if (requestParameters['customerIdIn'] != null) {
            queryParameters['customer_id__in'] = requestParameters['customerIdIn'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("firebase", []);
        }
        const response = await this.request({
            path: `/v1/invoices`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetCustomerInvoicesV1200ResponseFromJSON(jsonValue));
    }
    /**
     * List of all invoices
     */
    async getAllInvoicesV1(requestParameters = {}, initOverrides) {
        const response = await this.getAllInvoicesV1Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Invoice Details
     * Invoice Details
     */
    async getInvoiceDetailsV1Raw(requestParameters, initOverrides) {
        if (requestParameters['invoiceId'] == null) {
            throw new runtime.RequiredError('invoiceId', 'Required parameter "invoiceId" was null or undefined when calling getInvoiceDetailsV1().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("firebase", []);
        }
        const response = await this.request({
            path: `/v1/invoices/{invoice_id}`.replace(`{${"invoice_id"}}`, encodeURIComponent(String(requestParameters['invoiceId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetInvoiceDetailsV1200ResponseFromJSON(jsonValue));
    }
    /**
     * Invoice Details
     * Invoice Details
     */
    async getInvoiceDetailsV1(requestParameters, initOverrides) {
        const response = await this.getInvoiceDetailsV1Raw(requestParameters, initOverrides);
        return await response.value();
    }
}
